/* #region  Global region */

const getMaxQnaActiveStatus = (state) => state.maxQnaActive

const getHasOngoingQna = (state) => state.hasOngoingQna

const getVerifyUserAccount = (state) => state.verifyUserAccount

const getInputRecord = (state) => state.inputRecord

const getIsRegisterSuccess = (state) => {
  return state.isRegisterSuccess
}

const getOrigin = (state) => {
  return state.origin
}

const getLoading = (state) => {
  return state.isLoading
}

const getIsOpenTermCondition = (state) => {
  return state.isOpenTermCondition
}

const getIsOpenDisclaimer = (state) => {
  return state.isOpenDisclaimer
}

const getPagination = (state) => {
  return state.pagination
}

const getError = (state) => {
  return state.error
}

const getGsiError = (state) => {
  return state.gsiError
}

const getSuccess = (state) => {
  return state.success
}

const getNewNotif = (state) => {
  return state.newNotif
}

const getUser = (state) => {
  return state.user
}

const getMembership = (state) => {
  return state.membership
}

// const getAppVersion = (state) => {
//   return state.appVersion
// }

const getFilter = (state) => {
  return state.filter
}
const getSearch = (state) => {
  return state.search
}
const getOpenSearch = (state) => {
  return state.openSearch
}

const getYPos = (state) => {
  return state.scrollYPos
}

/* #endregion */

/* #region  liveTrade */
const getLiveTrading = (state) => {
  return state.liveTrade
}

const getLiveTradeDetail = (state) => {
  return state.liveTradeDetail
}
/* #endregion */

/* #region  stock */
const getMyStock = (state) => {
  return state.myStock
}
const getBuyStock = (state) => {
  return state.buyStock
}
const getSellStock = (state) => {
  return state.sellStock
}
const getAnalysisStock = (state) => {
  return state.analysisStock
}

const getListStock = (state) => {
  return state.listStock
}

const getLastPriceStock = (state) => {
  return state.lastPriceStock
}

const getChartStock = (state) => {
  return state.chartStock
}
/* #endregion */

/* #region  push notif */
const getPushNotif = (state) => {
  return state.pushNotif
}
/* #endregion */

/* #region  firebase */
const getFirebaseToken = (state) => {
  return state.firebaseToken
}
const getFirebaseRemoteConfig = (state) => {
  return state.firebaseRemoteConfig
}
/* #endregion */

/* #region  global filter */
const getCategory = (state) => {
  return state.selectedCategory
}
/* #endregion */

/* #region  Notification */
const getNotification = (state) => {
  return state.listNotification
}

const getNotifCategory = (state) => {
  return [{ name: 'Semua', slug: 'semua' }, ...state.listNotificationCategory]
}
/* #endregion */

/* #region  Read */
const getListContent = (state) => {
  return state.listContent
}
const getContentChild = (state) => {
  return state.listContentChild
}
const getContent = (state) => {
  return state.content
}

const getPromotionBanner = (state) => {
  return state.listPromotionBanner
}

const getTicker = (state) => {
  return state.listTicker
}

const getListEvent = (state) => {
  return state.listEvent
}
const getEducationHome = (state) => {
  return state.educationHome
}
const getAnalysisHome = (state) => {
  return state.analysisHome
}
const getFaqHome = (state) => {
  return state.faqHome
}
const getPromotionPopup = (state) => {
  return state.promotionPopup
}
const getCurrentPromotionPopup = (state) => {
  return state.currentPromotionPopup
}
const getPromotionPopupAppears = (state) => {
  return state.appearedPromotions
}
const getPromotion = (state) => {
  return state.promotion
}

/* #endregion */

/* #region  FAQ */
const getListFaq = (state) => {
  return state.listFaq
}
const getFaq = (state) => {
  return state.faq
}
const getListFaqRelated = (state) => state.listFaqRelated
const getFaqFrequent = (state) => {
  return state.faqFrequent
}
const getFaqLast = (state) => {
  return state.faqLast
}
/* #endregion */

/* #region  chat */
const getListChat = (state) => {
  return state.listChat
}

/* #endregion */

/* #region  Belanja */
const getListBelanja = (state) => {
  return state.listBelanja
}
/* #endregion */

/* #region  Belanja */
const getListLangganan = (state) => {
  return state.listLangganan
}
/* #endregion */

/* #region  categories */
const getCategories = (state) => {
  return state.categories
}
/* #endregion */

/* #region  tiket */
const getListTiket = (state) => {
  return state.listTiket
}
const getTiket = (state) => {
  return state.tiket
}
const getListTiketDetail = (state) => {
  return state.listTiketDetail
}
const getTiketDetail = (state) => {
  return state.tiketDetail
}

const getStatusQa = (state) => {
  return state.statusQa
}

const getPortfolioQa = (state) => state.portfolioQa

const getQnaRecord = (state) => state.qnaRecord

const getListQuestion = (state) => {
  return state.listQuestion
}

const getAutoAnswer = (state) => {
  return state.autoAnswer
}
/* #endregion */

/* #region analysis */
const getListAnalysis = (state) => {
  return state.listAnalysis
}
const getAnalysis = (state) => {
  return state.analysis
}
/* #endregion */

const getPageHistory = (state) => {
  return state.pageHistory
}

const getForYou = (state) => {
  return state.listForYou
}

const getLandingpage = (state) => {
  return state.landingpage
}

const getForgotSuccessDialog = (state) => {
  return state.forgotSuccessDialog
}

const getResendOTPRemaining = (state) => {
  return state.resendOTPRemaining
}

const getIsClosePopupBanner = (state) => {
  return state.isClosePopupBanner
}

export default {
  getIsRegisterSuccess,
  getOrigin,
  getIsOpenTermCondition,
  getIsOpenDisclaimer,
  getUser,
  getMembership,
  getLoading,
  getPagination,
  getNewNotif,
  getLiveTrading,
  getError,
  getGsiError,
  getSuccess,
  getBuyStock,
  getSellStock,
  getMyStock,
  getPushNotif,
  getNotifCategory,
  getFirebaseToken,
  getFirebaseRemoteConfig,
  getCategory,
  getNotification,
  getListContent,
  getContent,
  getListFaq,
  getFaq,
  getListChat,
  // getAppVersion,
  getListBelanja,
  getCategories,
  getFaqFrequent,
  getFaqLast,
  getListFaqRelated,
  getContentChild,
  getPromotionBanner,
  getTicker,
  getListEvent,
  getListLangganan,
  getListTiket,
  getTiket,
  getListTiketDetail,
  getTiketDetail,
  getAnalysisStock,
  getListStock,
  getLiveTradeDetail,
  getStatusQa,
  getListAnalysis,
  getAnalysis,
  getEducationHome,
  getAnalysisHome,
  getFaqHome,
  getLastPriceStock,
  getFilter,
  getSearch,
  getOpenSearch,
  getYPos,
  getAutoAnswer,
  getListQuestion,
  getChartStock,
  getPromotionPopup,
  getPromotion,
  getForYou,
  getInputRecord,
  getVerifyUserAccount,
  getMaxQnaActiveStatus,
  getPortfolioQa,
  getHasOngoingQna,
  getQnaRecord,
  getForgotSuccessDialog,
  getResendOTPRemaining,
  getIsClosePopupBanner,
  getCurrentPromotionPopup,
  getPromotionPopupAppears,
  getLandingpage,
  getPageHistory,
}
